import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=52e3836f&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e3836f')) {
      api.createRecord('52e3836f', component.options)
    } else {
      api.reload('52e3836f', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=52e3836f&", function () {
      api.rerender('52e3836f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qtxRESTzOewW/JS/IncreaseNumber.vue"
export default component.exports